<!-- Existing button/link trigger -->
<button
  *ngIf="shouldShowButton()"
  type="button"
  style="min-width: unset; white-space:nowrap;"
  [class]="buttonClass + ' mr-0'"
  [disabled]="!enabled"
  (click)="open()"
  [id]="moduleId + '_btn'"
  [title]="tooltip || ''"
  [ngStyle]="buttonStyling"
>
  {{ showButtonText && buttonText ? buttonText : '' }}
  <i
    *ngIf="showButtonText && btnIcon"
    class="material-icons"
    [ngStyle]="iconStyle"
    >{{ btnIcon }}</i>
</button>
<a
  *ngIf="shouldShowLink()"
  style="min-width: unset; white-space:nowrap;"
  (click)="open()"
  [id]="moduleId + '_btn'"
  [title]="tooltip || ''"
  href="#"
  [class.janus-anchor]="janusStyling"
>
  {{ showButtonText && buttonText ? buttonText : '' }}
  <i *ngIf="showButtonText && btnIcon" class="material-icons">{{ btnIcon }}</i>
</a>

<!-- Bootstrap Modal Template -->
<ng-template #content let-modal>
  <form [formGroup]="form">
    <div class="modal-header">
      <h4 class="modal-title" [id]="moduleId + '_modallabel'">{{ title }}</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        [disabled]="processing"
        (click)="modal.dismiss('Cross click')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <!-- Content will be inserted here dynamically -->
      <ng-container *ngTemplateOutlet="modalContentTemplate"></ng-container>
    </div>

    <div class="row ml-2 mr-2 mb-1">
      <div class="col-4 text-left">
        <ng-container *ngIf="customButtonText && customButtonText !== ''">
          <button
            type="button"
            [class]="'btn btn-' + customButtonColor"
            class="ml-2"
            [disabled]="processing"
            (click)="custom()"
          >
            {{ customButtonText }}
          </button>
        </ng-container>
      </div>

      <div class="col-8">
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default mr-2"
            [disabled]="processing"
            (click)="cancel()"
            *ngIf="showCancelButton && cancelText"
          >
            {{ cancelText }}
          </button>
          <button
            *ngIf="(commandText || '') !== '' && showCommandButton"
            type="button"
            [disabled]="(form && form.invalid) || processing"
            [class]="'btn btn-' + btnColor"
            class="mr-2"
            (click)="accept()"
          >
            <span
              *ngIf="processing"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            {{ commandText }}
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- Janus Styled Modal -->
<div class="janus-modal-backdrop" *ngIf="janusModalOpen && janusStyling" [ngClass]="isJanusMobileview ? 'janus-modal-backdrop-mobile' : ''" (click)="onJanusBackdropClick($event)">
  <div [ngClass]="[
      shareModalDesign ? 'share-modal-responsive' : 'janus-modal-content',
      isJanusMobileview ? 'janus-modal-content-mobile' : ''
    ]" [ngStyle]="{'max-width': janusModalWidth}" (click)="$event.stopPropagation()"
  >
    <!-- Close Button -->
    <button
      class="janus-close-button"
      (click)="cancelJanus()"
      [disabled]="processing"
      aria-label="Close"
    >
      &times;
    </button>

    <!-- Title -->
    <div class="janus-modal-title" [ngClass]="getJanusTitleClass()">
      {{ title }}
    </div>

    <!-- Body Content -->
    <div class="janus-modal-body">
      <!-- Content will be inserted here dynamically -->
      <ng-container *ngTemplateOutlet="modalContentTemplate"></ng-container>
    </div>

    <!-- Button Group -->
    <div class="janus-button-group">
      <!-- Custom Button -->
      <ng-container *ngIf="customButtonText && customButtonText !== ''">
        <button
          type="button"
          class="janus-btn janus-custom-btn"
          [disabled]="processing"
          (click)="customJanus()"
        >
          {{ customButtonText }}
        </button>
      </ng-container>

      <!-- Cancel Button -->
      <button
        type="button"
        class="janus-btn janus-cancel-btn"
        [disabled]="processing"
        (click)="cancelJanus()"
        *ngIf="showCancelButton && cancelText"
      >
        {{ cancelText }}
      </button>

      <!-- Accept/Command Button -->
      <button
        *ngIf="(commandText || '') !== '' && showCommandButton"
        type="button"
        class="janus-btn janus-accept-btn"
        [disabled]="(form && form.invalid) || processing"
        (click)="acceptJanus()"
      >
        <span
          *ngIf="processing"
          class="janus-spinner"
          role="status"
          aria-hidden="true"
        ></span>
        {{ commandText }}
      </button>
    </div>
  </div>
</div>

<!-- Hidden container to capture content -->
<ng-template #contentCapture>
  <ng-content></ng-content>
</ng-template>
